<template>
  <!-- 法律知识 -->
  <div class="homelay_knowledge text_center ">
    <sec-title
      ac-text="法律"
      Text="知识"
      desc-text="打造大型法律平台 永做法律知识传播者"
    />
    <div class="konwledge_content between">
		<div class="knowledge_left">
			<div class="leftimg_item between" v-for="item in 2">
				<img src="../../../assets/claim/audiosample.png" style="width: 100px;height: 74px;object-fit: cover;">
				<div class="itemtext flex-col ">
					<span class="FontSize16">男子侵占公款获刑</span>
					<span class="FontSize14 FontGray">在司法实践中，职务侵占的案件时经常发生...</span>
				</div>
			</div>
			<div class="ledgelist ">
				<div class="ledgeitem between FontSize14"  v-for="item in 6">
					<span class="FontGray">婚后生活</span>
					<span>民法点公司债务可否执行法人个人财产</span>
				</div>
			</div>
			<div class="thehetong text_center flex-col center">
				<span>法律文书范本</span>
				<span class="FontSize20"> 您的专属模板管家</span>
			</div>
		</div>
		<div class="knowledge_center flex-col">
			<div class="knowledge_swiper">
			  <el-carousel
			    trigger="click"
			    height="352px"
			    indicator-position="none"
			    arrow="never"
			    ref="knowledgeswipe"
			    @change="knowledge_c"
			  >
			    <el-carousel-item v-for="(item,index) in newslist.slice(0,3)" :key="index">
			      <img :src="item.preview_pic" alt="" />
			    </el-carousel-item>
			  </el-carousel>
			  <div class="know_swiper_bottom between">
			    <div class="bottom_text ellipsis">
			      <div class="ll"></div>
			      <!-- {{item.title}} -->
				  最新民法典关于担保制度司法解释
			    </div>
			    <div class="prev" @click="prev">
			      <svg-icon
			        icon-class="jt_right"
			        style="transform: rotate(180deg)"
			      ></svg-icon>
			    </div>
			    <div class="next" @click="next">
			      <svg-icon icon-class="jt_right"></svg-icon>
			    </div>
			  </div>
			</div>
			<!-- 法律解决方案 -->
			<div class="ks_top">
			  <div class="big_title">法律解决方案</div>
			  <div class="plan_tag between wrap">
						  <div 
						  :class="['plan_tag_item', 'flex-col', 'center', 'FontGray', 'FontSize14', index%3 == 2?'':'border-right',
						  index>solutioncats.length-4?'':'border-bottom']"
						   v-for="(item,index) in solutioncats" 
						  @click="tosolution(item.id)"
						  >
						  <svg-icon :icon-class="`homesutn_${index+1}`" style="width: 22px;height: 22px;"></svg-icon>
						  <span>{{item.cat_name}}</span>
						    <!-- <home-icon :iconSrc="`homesutn_${index+1}`" :iconText="item.cat_name" /> -->
						  </div>
			  </div>
			</div>
			
		</div>
		<div class="knowledge_right flex-col  between">
			<div  v-for="(item,index) in 4" @mouseenter="enterin(index)" @mouseleave="leaveout">
				<div class="rightitem flex_start" v-if="activeindex !== index">
					<img src="../../../assets/claim/aaaa1_sample.png" >
					<div class="flex-col">
						<span class="FontSize20">徐子城律师</span>
						<span class="FontSize16 FontGray">交通事故  婚姻家庭  财务纠纷</span>
						<span class="FontSize16"><i class="el-icon-phone FontBlue"></i> 1776588112</span>
					</div>
				</div>
				<div class="itemactive flex_start" v-if="activeindex == index">
					<img src="../../../assets/claim/aaaa1_sample.png" >
					<div class="flex-col inner">
						<span class="FontSize20">徐子城律师</span>
						<span class="FontSize16 FontGray">交通事故  婚姻家庭  财务纠纷</span>
						<span class="FontSize14 FontGray1" >思维敏捷缜密，具备了妥善出色处理各类案件的能力!</span>
					</div>
					<div class="btn">
						<span>在线咨询</span>
					</div>
				</div>
			</div>
			
		</div>
	</div>
    
  </div>
</template>

<script>
import homeIcon from "../components/homeIcon";
import layItemWin from "../components/layItemWin";
import secTitle from "../components/secTitle";
import subTitle from "../components/subTitle";
export default {
  name: "legalKnowledge",
  components: {
    secTitle,
    homeIcon,
    layItemWin,
    subTitle,
	
  },
  data() {
    return {
      swiper_current: 0,
	  newslist:[],
	  laywerlist:[],
	  solutioncats:'',
	  activeindex:Infinity
    };
  },
  created() {
  	this.$http.home.newslist().then(res => {
		this.newslist = res.data.data
 	})
	this.$http.home.solutioncats().then( res => {
		this.solutioncats = res.data
	})
	this.$http.home.lawyerads({
		ad_id:14,
		limit:4
	}).then( res => {
		this.laywerlist = res.data.data
	})
  },
  methods: {
	  enterin(index){
		  this.activeindex = index
	  },
	  leaveout(){
		  console.log('leave1')
		  this.activeindex = Infinity
	  },
    knowledge_c(item) {
      this.swiper_current = item;
    },
    prev() {
      this.$refs.knowledgeswipe.prev();
    },
    next() {
      this.$refs.knowledgeswipe.next();
    },
	todetail(id){
		this.$router.push({
		  path: "/jpcol/hdcht/conmodet",
		  query: {
		    hdartId: id,
		  },
		});
	},
	tosolution(id){
		this.$router.push({name:'fangan',params:{cat_id:id}});
		// this.$router.push({
		// 	path:"/jpcol/fangan",
		// 	query:{
		// 		cat_id:id
		// 	}
		// })
	}
  },
};
</script>

<style lang="scss" scoped>
.homelay_knowledge {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  
.knowledge_left{
	width: 306px;
	text-align: left;
	.leftimg_item{
		margin-bottom: 20px;
		.itemtext{
			margin-left: 13px;
		}
	}
	.ledgelist{
		.ledgeitem{
			margin-bottom: 18px;
		}
	}
	.thehetong{
		width: 306px;
		height: 168px;
		font-size: 26px;
		background-image: url(../../../assets/case/bg1.png) ;
		background-position: center;
		background-size: cover;
	}
}
 
.knowledge_center{
	width: 384px;
	.knowledge_swiper {
	    position: relative;
		height: 240px;
	    img {
	      width: 100%;
	      height: 240px;
	    }
	    .know_swiper_bottom {
	      position: absolute;
	      bottom: 0;
	      left: 0;
	      z-index: 10;
	      width: 100%;
	      line-height: 40px;
		  
	      .bottom_text {
	        text-align: left;
	        width: 296px;
			background: rgba(0, 0, 0, 0.4);
	        color: #ffffff;
	        padding-left: 9px;
			font-size: 14px;
	        .ll {
	          display: inline-block;
	          width: 4px;
	          height: 18px;
	          position: relative;
	          top: 3px;
	          background: #ffffff;
	          margin-right: 10px;
	        }
	      }
	      .prev,
	      .next {
			  width: 44px;
	        color: #fff;
	        background: #222222;
	        &:hover {
	          background-color: #0465ea;
	        }
	      }
	    }
	  }
	}
	.ks_top{
		margin-top: 40px;
	.big_title {
	  padding-left: 13px;
	  text-align: left;
	  font-size: 22px;
	  line-height: 22px;
	  border-left: 4px solid #0465ea;
	}	
	.plan_tag {
		margin-top: 24px;
		border: 1px solid #e3e3e3;
	  .plan_tag_item {
		  width: 33.33%;
		  height: 60px;
	  }
	  .border-right{
		  border-right: 1px solid #e3e3e3;
	  }
	  .border-bottom{
		  border-bottom: 1px solid #e3e3e3;
	  }
	}
	}
	
	.knowledge_right{
		width: 455px;
		height: 552px;
		.rightitem{
			width: 455px;
			height: 120px;
			border-radius: 10px;
			box-shadow: 5px 10px 10px #f7f7f7;
			text-align: left;
			background: url(../../../assets/case/bg2.png);
			img{
				width: 78px;
				height: 78px;
				margin-right: 17px;
			}
		}
		.itemactive{
		position: relative;
		width: 455px;
		height: 120px;
		align-items: flex-start;
		border-radius: 10px;
		box-shadow: 5px 10px 10px #f7f7f7;
		background-color: #fff;
		text-align: left;
		img{
			width: 40px;
			height: 40px;
			margin: 17px;
		}	
		.inner{
			height: 100%;
			justify-content: center;
		}
		.btn{
			position: absolute;
			width: 74px;
			height: 28px;
			background-color: #F25618;
			border-radius: 5px;
			text-align: center;
			color: #ffffff;
			right: 20px;
			top: 20px;
		}
		}
	}
	
}



</style>